<div class="guid-picker-bar">
  <button mat-stroked-button color="primary" type="button" (click)="openPicker()">Pick GUID</button>
  @if (fieldHint) {
    <span class="guid-picker-hint">{{fieldHint}}</span>
  }
</div>
